// injects a 0-width space between camelCased letters allowing them to break more gracefully
export const camelWrap = (str = '') => str.replace(/([a-z])([A-Z])/g, '$1\u200B$2');
